import { Box, Button, Icon, Text, Link } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  checkingStatus: boolean
  onStatusCheck: () => void
  pendingState: boolean
  pendingOver24h?: boolean
  isLeaveIncidence?: boolean
}

const Pending = ({
  checkingStatus,
  onStatusCheck,
  pendingState,
  pendingOver24h = false,
  isLeaveIncidence = false,
}: Props) => {
  const resolveTitle = () => {
    if (pendingOver24h) {
      return i18n.t('payroll_integrations.incidences.datev_lauds.hiring.pending.long_wait_title')
    }
    if (pendingState) {
      return i18n.t('payroll_integrations.incidences.datev_lauds.hiring.pending.waiting_title')
    }
    return i18n.t('payroll_integrations.incidences.datev_lauds.hiring.pending.title')
  }

  const resolveMessage = () => {
    if (pendingOver24h) {
      return i18n.tView(
        'payroll_integrations.incidences.datev_lauds.hiring.pending.long_wait_message',
        {
          link: (
            <Link.Href href={'https://help-center.apps.datev.de/documents/0903094'} target="_blank">
              {i18n.t('payroll_integrations.incidences.datev_lauds.hiring.pending.long_wait_link')}
            </Link.Href>
          ),
        }
      )
    }

    return isLeaveIncidence
      ? i18n.t('payroll_integrations.incidences.datev_lauds.absences.pending.message')
      : i18n.t('payroll_integrations.incidences.datev_lauds.hiring.pending.message')
  }

  return (
    <>
      <Box gap="s4" flexDirection="row">
        <Icon.Medium icon="spinner" color="viridian1000" />
        <Text.Header2>{resolveTitle()}</Text.Header2>
      </Box>
      <>{resolveMessage()}</>
      <Button onClick={onStatusCheck} disabled={checkingStatus}>
        {i18n.t('payroll_integrations.incidences.datev_lauds.hiring.pending.status_check')}
      </Button>
    </>
  )
}

export default Pending
